import { Receipt as InvoiceIcon } from "@mui/icons-material";
import { Chip } from "@mui/material";
import type { InvoiceMagicoTwin } from "@przezmorze/api-types";
import type { FC } from "react";
import { useOpenInvoicePdf } from "./useOpenInvoicePdf";

interface Props {
  readonly twin: InvoiceMagicoTwin;
}

const MagicoInvoiceChip: FC<Props> = ({ twin }) => {
  const openInvoicePdf = useOpenInvoicePdf();
  return (
    <Chip
      label={twin.number}
      variant="outlined"
      color="info"
      onClick={(e) => {
        e.stopPropagation();
        return openInvoicePdf(twin.pdfUrl);
      }}
      icon={<InvoiceIcon />}
    />
  );
};

export default MagicoInvoiceChip;
